import { createAsyncThunk } from "@reduxjs/toolkit";
import { normalize } from "normalizr";
import { tag } from "store/schemas";

import magnifiAPI from "../../services/api/magnifi";

export const getTags = createAsyncThunk("tags/getTags", async (payload) => {
  try {
    const response = await magnifiAPI.getTags(payload);

    return {
      ...response.data,
      ...(response.data.success ? normalize(response.data.tag, [tag]) : {}),
    };
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const addTags = createAsyncThunk("/tag/create", async (payload) => {
  try {
    const response = await magnifiAPI.createTags(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const deleteTag = createAsyncThunk("/tag/delete", async (payload) => {
  try {
    const response = await magnifiAPI.deleteTags(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const addTagThroughCsv = createAsyncThunk("/tag/addTagThroughCsv", async (payload) => {
  try {
    const response = await magnifiAPI.addTagThroughCsv(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const validateAddTagThroughCsv = createAsyncThunk("/tag/validateAddTagThroughCsv", async (payload) => {
  try {
    const response = await magnifiAPI.validateAddTagThroughCsv(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const createCombinedTagsThroughCsv = createAsyncThunk("/tag/createCombinedTagsThroughCsv", async (payload) => {
  try {
    const response = await magnifiAPI.createCombinedTagsThroughCsv(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});
export const createBulkTags = createAsyncThunk("/tag/createBulkTags", async (payload) => {
  try {
    const response = await magnifiAPI.createBulkTags(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const editTags = createAsyncThunk("/tag/editTags", async (payload) => {
  try {
    const response = await magnifiAPI.editTags(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const updateImageTags = createAsyncThunk("/tag/updateImageTags", async (payload) => {
  try {
    const response = await magnifiAPI.updateImageTags(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const checkImgNameAvailability = createAsyncThunk("/tag/checkImgNameAvailability", async (payload) => {
  try {
    const response = await magnifiAPI.checkImgNameAvailability(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});
